<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="">Inicio</a></li>
                <li><a routerLink="/tramites-configuracion">Configuración Categorías</a></li>
                <li>Listado de Categorías</li>
            </ul>
            <h2>Listado de Categorías</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<app-spinner
    [show]="!flagLoaded"
    [text]="'Cargando categorías...'"
    [type]="'fullscreen'"
    [color]="'#124e91'"
    [trackColor]="'#1c75bc'"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="flagLoaded" class="profile-area pb-70 contenido-tabla">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Categorías</h3>
            <hr>
            <div *ngIf="flagLoaded">
                <mat-form-field>
                    <mat-label>Filtrar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar por denominación..." autocomplete="off">
                </mat-form-field>
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                    <!-- Column for Denominación -->
                    <ng-container matColumnDef="denominacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Denominación </th>
                        <td mat-cell *matCellDef="let element"> {{element.denominacion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="verCategoria(element._id)" type="button" class="btn btn-warning"><i class="fas fa-edit"></i></button>
                            <button (click)="eliminarCategoria(element._id)" type="button" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                        </td>
                    </ng-container>

                    <!-- Table Header and Body -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
            </div>
        </div>
    </div>
</div>

<!-- Modal confirmar eliminación -->
<app-pop-up-modal-custom
    [show]="showEliminarModal"
    titulo="¿Eliminar categoría?"
    mensaje="La categoría será borrada permanentemente."
    tipo="warning"
    textoBoton="Sí, eliminar"
    textoBotonCancelar="Cancelar"
    (confirmado)="confirmarEliminar()"
    (cerrado)="showEliminarModal = false"
></app-pop-up-modal-custom>

<!-- Modal eliminada con éxito -->
<app-pop-up-modal-custom
    [show]="showEliminadaModal"
    titulo="Eliminada"
    mensaje="La categoría ha sido eliminada."
    tipo="success"
    textoBoton="Aceptar"
    (confirmado)="showEliminadaModal = false"
></app-pop-up-modal-custom>

<!-- Modal error al eliminar -->
<app-pop-up-modal-custom
    [show]="showErrorEliminarModal"
    titulo="No se pudo eliminar"
    mensaje="Ocurrió un error al eliminar la categoría. Intentá nuevamente."
    tipo="error"
    textoBoton="Aceptar"
    (confirmado)="showErrorEliminarModal = false"
></app-pop-up-modal-custom>
